/**
 * stat.js
 * 统计、埋点
 */

/*
ext:
 stat.init({bridge: new Bridge()});
 stat.send({name:"事件名称",properties{key:value}});
 */

import Bridge from '../../lib/Bridge'
import ZxsBridge from '../../lib/zxsBridge'
// import { getRunningEnv, getPlatform } from '../../tools/getPlatform'
import { pick } from '../../tools/objOperation'
import ZHUGEKEYS from './zhugeIO_keys'
import getPlatformTools from '../../tools/getPlatform'
const { getRunningEnv, getPlatform } = getPlatformTools
import {
  businessList,
  businessMap,
  eventTypeMap,
  eventAttributeList,
  eventAttributeMap
} from './statFiled'

class stat {
  constructor({
    platform,
    globalParams = {},
    interceptor,
    customTrackConfig = {}
  } = {}) {
    console.log('初始化 Stat 对象：', platform, globalParams)
    this.platform = getPlatform()
    this.curPlatform = platform || ''
    this.runningEnv = getRunningEnv()
    if (this.platform.isYixinliApp || this.platform.isCeShiApp) {
      this.bridge = new Bridge()
    }
    if (this.platform.isZiXunShiApp) {
      this.zxsBridge = new ZxsBridge()
    }
    this.globalParams = globalParams
    this.interceptor = interceptor
    this.zhugeSDK(platform, customTrackConfig)
  }
  init() {
    // 兼容旧代码的init方法写法
    return this
  }

  setGlobalParams(globalParams = {}) {
    this.globalParams = Object.assign(this.globalParams, globalParams)
  }

  zhugeSDK(platform, sdkConfig) {
    if (window.zhuge) return
    window.zhuge = window.zhuge || []
    window.zhuge.methods = '_init debug identify track getDid getSid getKey setSuperProperty setUserProperties setWxProperties setPlatform'.split(
      ' '
    )
    // window.zhuge.methods = '_init debug identify track trackLink trackForm page'.split(' ');
    window.zhuge.factory = function(b) {
      return function() {
        var a = Array.prototype.slice.call(arguments)
        a.unshift(b)
        window.zhuge.push(a)
        return window.zhuge
      }
    }
    for (var i = 0; i < window.zhuge.methods.length; i++) {
      var key = window.zhuge.methods[i]
      window.zhuge[key] = window.zhuge.factory(key)
    }
    window.zhuge.load = function(b, x) {
      window.zhuge.identify = window.zhuge.track = function(
        ename,
        props,
        callback
      ) {
        if (
          callback &&
          Object.prototype.toString.call(callback) === '[object Function]'
        ) {
          callback()
        } else if (
          Object.prototype.toString.call(props) === '[object Function]'
        ) {
          props()
        }
      }
    }

    // 配置应用的AppKey
    // 根据 WEBPACK_DEV 开启是否debug，不用每次都进行开关
    // 正式环境且是生产模式，不debug
    let useKey
    let localPlatform
    if (platform && ZHUGEKEYS[platform]) {
      useKey = ZHUGEKEYS[platform]
      localPlatform = platform
    } else {
      if (this.platform.isYixinliApp) {
        useKey = ZHUGEKEYS.yxlApp
        localPlatform = 'yxlApp'
      } else if (this.platform.isCeShiApp) {
        useKey = ZHUGEKEYS.cpApp
        localPlatform = 'cpApp'
      } else if (this.platform.isPc) {
        useKey = ZHUGEKEYS.yixinliPC
        localPlatform = 'yixinliPC'
      } else if (this.platform.isZiXunShiApp) {
        useKey = ZHUGEKEYS.homeOfConsultants
        localPlatform = 'homeOfConsultants'
      } else {
        useKey = ZHUGEKEYS.msite
        localPlatform = 'msite'
      }
    }

    // 取出SDK支持的配置参数
    let filtedConfig = pick(sdkConfig, [
      'superProperty',
      'adTrack',
      'zgsee',
      'autoTrack',
      'singlePage'
    ])
    console.log(
      '当前环境：',
      this.runningEnv.env,
      '是否开启Debug：',
      this.runningEnv.isDev,
      `使用${localPlatform}的KEY`,
      '配置项：',
      filtedConfig
    )
    this.curPlatform = localPlatform
    var finalConfig = Object.assign(
      {},
      { debug: this.runningEnv.isDev },
      filtedConfig
    )

    /*如果是全埋点，添加任意元素可点击事件*/
    console.log('是否开启全埋点', sdkConfig && sdkConfig.autoTrack)
    if (sdkConfig && sdkConfig.autoTrack) {
      finalConfig = {
        ...finalConfig,
        isClickAble: function() {
          //targetElement为点击的dom元素
          return true
        }
      }
    }

    window.zhuge.load(useKey, finalConfig)

    // if (window.loginUserId) {
    //     window.zhuge.identify(String(window.loginUserId));
    //     console.log(window.loginUserId);
    // }
  }
  send(data) {
    if (typeof data === 'string') {
      data = {
        name: data
      }
    }
    this.statSend(data)
  }
  /**
   * 标记用户的方法，在后台可以看到具体的属性
   * @param {*} id 唯一标识
   * @param {*} properties 补充说明属性
   */
  identify(id, properties = {}) {
    try {
      window.zhuge.identify(String(id), properties)
    } catch (error) {
      console.error(error)
    }
  }

  statSend(data) {
    const sendFlow = Promise.resolve()
    if (this.interceptor && typeof this.interceptor === 'function') {
      sendFlow.then(() => {
        return this.interceptor()
      })
    }
    sendFlow
      .then(() => {
        // 由于诸葛IO SDK升级，能够设置全局属性，但是为了兼容客户端和维持web的灵活性，还是使用自己维护的globalParams
        let resultParams = {}
        if (
          typeof this.globalParams === 'object' &&
          Object.keys(this.globalParams).length > 0
        ) {
          // TODO: 校验globalParams，key的类型，如果是多层Object，将Object抽出来
          // for (let key in  this.globalParams) {
          //     resultParams[key] = typeof(this.globalParams[key] !== ) ? this.globalParams[key] : undefined;
          // }
          data.properties = Object.assign(
            {},
            this.globalParams,
            data.properties
          )
        }
        data.properties = Object.assign({}, resultParams, data.properties)

        if (
          this.curPlatform === 'yxlApp' &&
          (this.platform.isYixinliApp || this.platform.isCeShiApp)
        ) {
          // 是壹心理App但是指定使用的key不是yxlApp的时候，不要给客户端代理埋点
          // app代理埋点
          this.bridge.call('stat', data)
        } else if (
          this.curPlatform === 'homeOfConsultants' &&
          this.platform.isZiXunShiApp
        ) {
          // app代理埋点
          this.zxsBridge.call('statForBridge', {
            eventName: data.name,
            param: JSON.stringify(data.properties)
          })
        } else {
          // web埋点
          window.zhuge.track(data.name, data.properties)
        }
      })
      .catch(e => {
        console.log(e)
      })
  }

  /**
   * 页面访问-埋点公共方法
   * @param {Object} params
   * @param {String} params.businessType 事件所属业务
   * @param {String} [params.category] 产品
   * @param {String} params.eventValue 属性值
   * @param {Object} params.extraAttr 额外属性
   */
  visit(params) {
    params.eventType = 1
    params.eventAttribute = '页面'
    this.handleStat(params)
  }

  /**
   * 交互行为-埋点公共方法
   * @param {Object} params
   * @param {String} params.businessType 事件所属业务
   * @param {String} [params.category] 产品
   * @param {String} params.eventValue 属性值
   * @param {String} params.pageTitle 页面title
   * @param {Object} params.extraAttr 额外属性
   */
  interact(params) {
    params.eventType = 2
    params.eventAttribute = '对象'
    this.handleStat(params)
  }

  /**
   * 社交行为-埋点公共方法
   * @param {Object} params
   * @param {String} params.businessType 事件所属业务
   * @param {String} [params.category] 产品
   * @param {String} params.eventAttribute 主要事件属性：页面，对象
   * @param {String} params.eventValue 属性值
   * @param {String} [params.pageTitle] 页面title
   * @param {Object} params.extraAttr 额外属性
   */
  social(params) {
    params.eventType = 3
    this.handleStat(params)
  }

  // 不同类型埋点统一处理
  handleStat(params) {
    const {
      businessType,
      category,
      eventType,
      eventAttribute,
      eventValue,
      pageTitle,
      extraAttr = {}
    } = params
    this.checkStatParams(params)
      .then(() => {
        const name = `${businessType}-${category ? category + '-' : ''}${
          eventTypeMap[eventType]
        }`
        const properties = {
          [eventAttribute]: eventValue,
          ...extraAttr
        }
        if (eventAttribute === '对象' && pageTitle) {
          properties['页面'] = pageTitle
        }
        this.statSend({
          name,
          properties
        })
      })
      .catch(e => {
        console.error(
          '请检查传入参数是否有误，详情查看http://112.124.122.87:8090/pages/viewpage.action?pageId=6554041'
        )
      })
  }

  // 校验埋点参数与数据回传
  checkStatParams(params) {
    return new Promise((resolve, reject) => {
      const {
        businessType,
        category,
        eventType,
        eventAttribute,
        pageTitle,
        eventValue
      } = params

      if (!businessType) {
        console.error('请传入事件所属业务', businessList)
        reject()
      }

      // if (window && window.monitor && !businessList.includes(businessType)) {
      //   console.error('事件所属业务错误，请传入对应业务名称')
      //   window.monitor.stat({
      //     logType: 'info',
      //     title: '埋点所属业务没有配置businessList',
      //     message: JSON.stringify({
      //       businessType,
      //       category,
      //       pageTitle,
      //       eventValue
      //     }),
      //     remark: businessType
      //   })
      // }

      if (!eventAttributeList.includes(eventAttribute)) {
        console.error('主要事件属性错误，请传入对应事件属性名称')
        reject()
      }
      if (!eventValue) {
        console.error('请传入属性值')
        reject()
      }
      if (eventAttribute === '对象' && !pageTitle) {
        console.error('主要事件属性为对象时，需传入pageTitle')
        reject()
      }

      // debug环境下，进行埋点数据回传
      if (
        this.runningEnv.isDev ||
        (window && location.hostname === 'localhost')
      ) {
        let param = {
          businessType: businessMap[businessType],
          eventType,
          eventAttribute: eventAttributeMap[eventAttribute],
          eventValue
        }
        if (category) {
          param['category'] = category
        }
        // this.returnStat(
        //   (window ? window.location.protocol : '') +
        //     '//lx.xinli001.com/user/event/sureSuccess',
        //   param
        // ).then(res => {
        //   if (+res.code !== 0) {
        //     console.error(res.msg)
        //   }
        // })
      }
      resolve()
    })
  }

  // 埋点事件回传
  returnStat(url, params) {
    return new Promise(resolve => {
      // FormData 对象
      let form = new FormData()
      Object.keys(params).forEach(key => {
        form.append(key, params[key])
      })
      let xhr = new XMLHttpRequest()
      xhr.open('post', url, true)
      xhr.onload = function() {
        let result = JSON.parse(xhr.responseText)
        resolve(result)
      }
      xhr.send(form)
    })
  }
}

// window.yxl = window.yxl || {};
// window.yxl.stat = stat;
// return stat;

export default stat
export { stat }

/**
 * ext:
 * stat.init({bridge: new Bridge()});
 * stat.send({name:"事件名称",properties{key:value}});
 */



// WEBPACK FOOTER //
// ./src/frontend-lib/lib/stat/Stat.js